"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchTroubleshootTimesRequest = void 0;

var _endpoints = require("MeetingsLib/constants/endpoints");

var fetchTroubleshootTimesRequest = function fetchTroubleshootTimesRequest(httpClient, slug, portalId) {
  return httpClient.get("" + _endpoints.TROUBLESHOOT_ENDPOINT, {
    ignoreRedirect: true,
    query: {
      slug: slug,
      portalId: portalId
    }
  });
};

exports.fetchTroubleshootTimesRequest = fetchTroubleshootTimesRequest;